import type { ReactNode } from 'react'
import React from 'react'
import { Col, Row, Stack } from 'react-bootstrap'
import { Box } from '@ztechapps/webui.util'
import { useAccountJoinContext } from './Context'

export type AccountJoinContainerProps = { title: ReactNode; description: ReactNode; children: ReactNode }
export const AccountJoinContainer = ({ title, description, children }: AccountJoinContainerProps) => {
  const { logo } = useAccountJoinContext()

  return (
    <Row className="g-5">
      <Col md={12}>{logo}</Col>

      <Col md={6}>
        <Stack gap={4}>
          <h2 className="fw-bold">{title}</h2>

          <div>{description}</div>
        </Stack>
      </Col>
      <Col md={6}>
        <Box>
          <Stack gap={3}>{children}</Stack>
        </Box>
      </Col>
    </Row>
  )
}
